import React from "react";
import styled from "styled-components";
import { Table } from 'antd';

const Title = styled.div`
  font-style: normal;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 5px;
  opacity: 0.99;
`;

type MiniTableProps = {
  data: any,
  title: string,
  columns: any,
  probabilistic?: boolean
}

const MiniTable = (props: MiniTableProps) => {
  const { data, title, columns, probabilistic } = props;
  return (
    <>
      <div className="table-view-container">
        <Title>{unescape(title)}{probabilistic ? <sup>*</sup> : ''}</Title>
        <Table columns={columns} dataSource={data} pagination={false} />
        {probabilistic && (<span style={{ color: '#c2c2c2', fontSize: '12px', position: 'absolute', right:'45px'}}>Data sampled from top 10,000 profiles</span>)}
      </div>
    </>
  );
}

export default MiniTable;
